module.exports = __webpack_public_path__ + "media/toneSection.cf95912c.mp3";